import React from "react";
import { Box, Button, Dialog, Stack } from "@origin-digital/ods-core";
import { CloseTransferWarningModalMessageType } from "./types";
import {
  CloseTransferWarningMessageContentNotRequired,
  CloseTransferWarningMessageContentProcessed,
} from "./CloseTransferWarningDialog/CloseTransferWarningMessageContent";

interface ICloseTransferWarningModal {
  open: boolean;
  setOpen: (open: boolean) => void;
  onUpdate: () => void;
  warningMessageType: CloseTransferWarningModalMessageType;
}

export const CloseTransferWarningModal = ({
  open,
  setOpen,
  onUpdate,
  warningMessageType,
}: ICloseTransferWarningModal) => {
  const onUpdateStatus = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onUpdate();
    setOpen(false);
  };

  return (
    <Dialog id="dialog" open={open} title="Are you sure?" hideClose={true}>
      <Stack space="small">
        {/* Content */}
        {warningMessageType ==
          CloseTransferWarningModalMessageType.NOT_REQUIRED && (
          <CloseTransferWarningMessageContentNotRequired />
        )}
        {warningMessageType ==
          CloseTransferWarningModalMessageType.PROCESSED && (
          <CloseTransferWarningMessageContentProcessed />
        )}
        {/* End Content */}

        {/* Actions */}
        <Box
          position={{
            lg: "static",
            xs: "fixed",
          }}
          paddingTop={{
            lg: "medium",
            xs: "medium",
          }}
          paddingBottom={{
            lg: "none",
            xs: "large",
          }}
          paddingX={{
            lg: "none",
            xs: "medium",
          }}
          backgroundColor="white"
          width="full"
          style={{
            left: "0",
            bottom: "0",
            zIndex: "1",
          }}
        >
          <Box
            display="flex"
            flexWrap={{
              lg: "nowrap",
              xs: "wrap",
            }}
            justifyContent="flex-end"
            alignItems="center"
          >
            <Box marginRight="large">
              <Button
                variant="text"
                color="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpen(false);
                }}
              >
                Cancel
              </Button>
            </Box>
            <Button onClick={(e) => onUpdateStatus(e)}>Update status</Button>
          </Box>
        </Box>
        {/* End Actions */}
      </Stack>
    </Dialog>
  );
};
